import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import BreachesDiscoveredTable from "./BreachesDiscoveredTable";

const BreachesDiscoveredModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Breaches Discovered
			</DialogTitle>
			<DialogContent>
				<BreachesDiscoveredTable breaches={props.breaches}/>
			</DialogContent>
		</Dialog>
	);

}

export default BreachesDiscoveredModal;